import React from "react";
import { Loader2, Save, X } from "lucide-react";
import { Step1GameStats } from "./Step1GameStats";
import { Step2ShotSelection } from "./Step2ShotSelection";
import { Layer2Film } from "./Layer2Film";
import { Layer3Mechanics } from "./Layer3Mechanics";
import { Layer4Routines } from "./Layer4Routines";
import { TextArea, Label } from "./ui";
import { derive } from "./evalModel";

// Four layers on one page: Results -> Film / Training -> Mechanics & Constraints -> Routines.
export function EvalEditor({ L, ev, setEv, onSave, onCancel, saving, playerId, gamesPlayed }) {
  const set = (patch) => setEv(prev => ({ ...prev, ...patch }));
  const { breakdown } = derive(ev);
  const picks = ev.layer3.checkpoint_ids.length;
  const canSave = ev.date && ev.assessed_by.trim() && picks <= 3;

  return (
    <div className="space-y-4" data-testid="se-editor">
      <div className="border border-white/10 bg-[#141414] p-5 grid grid-cols-1 md:grid-cols-3 gap-3">
        <label className="block"><Label>Date</Label><input type="date" value={ev.date} onChange={e => set({ date: e.target.value })} className="w-full bg-[#0f0f0f] border border-white/10 px-3 py-2 text-sm text-white focus:outline-none focus:border-[var(--org-accent)]" data-testid="se-date" /></label>
        <label className="block"><Label>Assessed by</Label><input value={ev.assessed_by} onChange={e => set({ assessed_by: e.target.value })} className="w-full bg-[#0f0f0f] border border-white/10 px-3 py-2 text-sm text-white focus:outline-none focus:border-[var(--org-accent)]" data-testid="se-assessed-by" /></label>
        <div><Label>Library</Label><div className="text-sm text-[#a0a0a0] py-2">{L.version}</div></div>
      </div>

      <Step1GameStats L={L} ev={ev} set={set} playerId={playerId} gamesPlayed={gamesPlayed} />
      <Step2ShotSelection L={L} ev={ev} set={set} />
      <Layer2Film L={L} ev={ev} set={set} />
      <Layer3Mechanics L={L} ev={ev} set={set} breakdown={breakdown} />
      <Layer4Routines L={L} ev={ev} playerId={playerId} eid={null} />

      <div className="border border-white/10 bg-[#141414] p-5 space-y-4">
        <TextArea label="Assessment notes" value={ev.notes} onChange={v => set({ notes: v })} testid="se-notes" rows={3} />
        <div className="flex items-center justify-end gap-2">
          <button type="button" onClick={onCancel} className="px-4 py-2 border border-white/10 text-[#a0a0a0] text-[10px] uppercase tracking-[0.3em] font-bold flex items-center gap-1.5 hover:text-white" data-testid="se-cancel"><X className="w-3 h-3" /> Cancel</button>
          <button type="button" onClick={onSave} disabled={!canSave || saving} className="px-4 py-2 bg-[var(--org-accent)] text-[#121212] text-[10px] uppercase tracking-[0.3em] font-bold flex items-center gap-1.5 disabled:opacity-40" data-testid="se-save">
            {saving ? <Loader2 className="w-3 h-3 animate-spin" /> : <Save className="w-3 h-3" />} Save assessment
          </button>
        </div>
      </div>
    </div>
  );
}
